// extracted by mini-css-extract-plugin
export var arrow = "_d-8";
export var fadeIn = "_d-1";
export var header = "_d-4";
export var image = "_d-3";
export var link = "_d-7";
export var modal = "_d-2";
export var overlay = "_d-0";
export var subtitle = "_d-6";
export var title = "_d-5";